var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularProgressMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 71,
    viewBox: "0 0 76 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1906 69.7025C63.2575 65.6224 68.7674 59.3085 71.8533 51.7543C74.9392 44.2001 75.426 35.8343 73.237 27.9731C71.048 20.112 66.3076 13.2017 59.7615 8.32954C53.2154 3.45738 45.2353 0.899868 37.0766 1.0594C28.9179 1.21894 21.0439 4.08646 14.6933 9.2108C8.34266 14.3351 3.87598 21.4255 1.99599 29.3662C0.116012 37.3069 0.929438 45.6472 4.30829 53.0751C7.68714 60.5029 13.4396 66.5965 20.6607 70.3972",
    stroke: "#6BFE94",
    strokeLinecap: "round",
    strokeDasharray: "0 1 14 0 1 14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularProgressMask);
export default __webpack_public_path__ + "static/media/circular-progress-mask.08acf492d3ca9c97e09f297b3bb6a487.svg";
export { ForwardRef as ReactComponent };